exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".v-carousel-wrap[data-v-5114fc69]{background-color:rgba(162,182,199,.05);padding:10px 5px 0}.v-carousel-wrap .carousel-item[data-v-5114fc69]{cursor:pointer;width:100%}.v-carousel-wrap .v-carousel__controls[data-v-5114fc69]{position:static}", ""]);
